import React from "react";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/contexts/PageTitlesContext";

export default function About() {
  const { t, i18n } = useTranslation();
  const zh = !i18n.language?.startsWith("en");
  const pt = usePageTitle("about", { title_zh: t("nav.about"), title_en: t("nav.about"), subtitle_zh: "about", subtitle_en: "about" });
  return (
    <div className="mx-auto max-w-4xl px-6 lg:px-10 py-20" data-testid="about-page">
      <div className="text-xs uppercase tracking-[0.3em] text-[#00868e] font-semibold" data-testid="about-subtitle">
        {zh ? (pt.subtitle_zh || "about") : (pt.subtitle_en || "about")}
      </div>
      <h1 className="mt-3 font-serif-cn text-4xl md:text-5xl text-[#003645] font-semibold tracking-tight" data-testid="about-title">
        {zh ? pt.title_zh : pt.title_en}
      </h1>

      <div className="mt-10 space-y-6 text-[#4a6e77] leading-[1.9] font-serif-cn text-[17px]">
        {zh ? (
          <>
            <p>
              晶灵文创 (JinLin Creative) 是一家承载东方文化底蕴的现代文创品牌，
              专注于水晶、风水、能量、香与莲花等主题产品的精选与研发。
            </p>
            <p>
              我们相信，每一件器物皆有其灵。以匠心与温度选材，让传统美学融入当代生活，
              为您与家人带来一份宁静、一份守护、一份属于晶灵的美好。
            </p>
            <p>
              未来阶段，我们将陆续推出零度空间冥想课程、Angelina 晶灵代言人、水晶百科、
              人生预约与今日运程等模块，与您共同探索心灵成长的旅程。
            </p>
          </>
        ) : (
          <>
            <p>
              JinLin Creative is a modern cultural-creative brand rooted in Eastern
              tradition — thoughtfully curating crystals, fengshui pieces, energy
              tools, incense and lotus-inspired objects.
            </p>
            <p>
              We believe every object carries a spirit. With craftsmanship and
              warmth, we bring classical aesthetics into contemporary life —
              stillness, protection, and quiet beauty for you and your family.
            </p>
            <p>
              In upcoming phases we will introduce Zero Space meditation
              programs, Angelina brand ambassadorship, a crystal encyclopedia,
              life-path booking, and daily fortune modules — a journey of the
              spirit, together.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
